import React, { useState } from 'react';

import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material';
import { isEmpty } from 'ramda';

interface NotePopupProps {
  open: boolean;
  onClose(): void;
  addNote(text: string): void;
}

const NotePopup: React.FC<NotePopupProps> = (props) => {
  const [noteText, setNoteText] = useState<string>('');
  const [errorMessage, setErrorMessage] = useState('');

  const handleAdd = () => {
    if (noteText) {
      props.addNote(noteText);
      setNoteText('');
      setErrorMessage('');
    } else {
      setErrorMessage('You must enter some note text.');
    }
  };

  return (
    <>
      <Dialog open={props.open} onClose={props.onClose} aria-labelledby='form-dialog-title' maxWidth='sm' fullWidth>
        <DialogTitle id='form-dialog-title'>Add Note</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin='dense'
            id='note-text'
            label='Note'
            value={noteText}
            onChange={(e) => setNoteText(e.currentTarget.value)}
            fullWidth
            multiline
            error={!!errorMessage}
            helperText={errorMessage}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={props.onClose} color='primary' variant='outlined'>
            Close
          </Button>
          <Button onClick={handleAdd} color='primary' variant='contained' disabled={isEmpty(noteText)}>
            Add Note
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default NotePopup;
